<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <div class="rj-row">
        <el-form ref="form" :model="formData" :rules="rules">
          <el-form-item prop="byType" label="请选择下单方式">
            <el-radio-group v-model="formData.byType">
              <el-radio v-if="!baseInfo.distributorCode" :label="1">
                从锐捷下单
              </el-radio>
              <!-- <el-radio :label="1" v-if="isShow">从锐捷下单</el-radio> -->
              <el-radio v-if="baseInfo.distributorCode" :label="2">
                从分销商下单
              </el-radio>
              <el-radio :label="3">
                拒绝接单
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="formData.byType==3" prop="reason">
            <el-input v-model.trim="formData.reason" type="textarea" :rows="4" placeholder="请输拒绝理由" show-word-limit maxlength="200" />
          </el-form-item>
          <el-form-item style="margin-bottom: 4px">
            <el-button type="primary" :loading="loading" @click="submit">
              确认
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { mapActions } from 'vuex';
import { IntegratorsConfirmOrRefusOrder, getLoginUser } from '../../../../API/index';
import eventBus from '@/libs/eventBus';
export default {
  data () {
    return {
      formData: {
        byType: '',
        reason: ''
      },
      loading: false,
      rules: {
        reason: [{ required: true, message: '请输拒绝理由', trigger: 'blur' }],
        byType: [{ required: true, message: '请选择下单方式', trigger: 'change' }]
      },
      isShow: true,
      signType: ''
    };
  },
  props: {
    // 数据由父组件传递
    baseInfo: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'getIsCurrentApprover'
    ]),
    submit () {
      this.$refs.form.validate(async (val) => {
        // 输入验证成功后 调用接口
        if (val) {
          // let isApprover = await this.getIsCurrentApprover(this.baseInfo.documentID);
          // if (!isApprover) {
          let params = {
            documentID: this.baseInfo.documentID,
            orderType: this.baseInfo.orderType,
            optionType: '1',
            nextForm: this.formData.byType,
            newEcpFlag: Number(this.$route.query.newEcpFlag)
          };
          if (this.formData.byType === 1) {
            params.optionType = '1';
            params.nextForm = 2;// 锐捷下单
          } else if (this.formData.byType === 2) {
            params.optionType = '1';
            params.nextForm = 1;// 分销下单
          } else if (this.formData.byType === 3) {
            params.optionType = '1';
            params.nextForm = 3; // 拒绝接单
            params.reason = this.formData.reason;
          }
          this.loading = true;
          IntegratorsConfirmOrRefusOrder(params).then((res) => {
            this.loading = false;
            let json = res.data;
            if (json.status === '200') {
              eventBus.$emit('CompleteChiefOrder'); // 完成订单操作
              this.$router.replace({
                name: 'ChiefOrderList'
              });
            }
          }).catch(() => {
            this.loading = false;
          });
        }
        // }
      });
    },
    getUser () {
      getLoginUser().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.signType = json.data.signType;
          if (this.baseInfo.directOrder) {
            this.isShow = true;
          } else {
            if (this.signType === '行业金牌' || this.signType === '商业金牌' || this.signType === '县级商业金牌' || this.signType === '银牌合作伙伴' || this.signType === '认证合作伙伴') {
              this.isShow = false;
            } else {
              // 无 分销商 有首级 隐藏 从锐捷下单选项
              if (!this.baseInfo.distributorCode && this.baseInfo.integratorsCode) {
                this.isShow = false;
              } else {
                this.isShow = true;
              }
            }
          }
        }
      }).catch((res) => {

      });
    }
  },
  mounted () {
    this.getUser();
  }
};
</script>
<style lang="scss">
</style>
